import { css } from 'styled-components';
import { breakpoints } from '../../../../../styles/theme';

const XSmall = css`
  padding: 0;
  font-size: 10px;
  font-weight: 400;
  line-height: 170%;
`;

const Small = css`
  padding: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
`;

const Medium = css`
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
`;

const Large = css`
  padding: 0;
  font-size: 20px;
  font-weight: 400;
  line-height: 150%;
`;

export const ButtonMenuLinkStyle = css`
  width: fit-content;

  @media (max-width: ${breakpoints.xs}px) {
    ${XSmall}
  }
  @media (max-width: ${breakpoints.sm}px) {
    ${Small}
  }
  @media (min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.md}px) {
    ${Medium}
  }
  @media (min-width: ${breakpoints.md}px) {
    ${Large}
  }

  // Override default size if specific size is provided
  &.x-small {
    ${XSmall}
  }
  &.small {
    ${Small}
  }
  &.medium {
    ${Medium}
  }
  &.large {
    ${Large}
  }
`;
